/* tslint:disable */

declare var Object: any;
export interface ERPaccountingInterface {
  "id"?: number;
}

export class ERPaccounting implements ERPaccountingInterface {
  "id": number;
  constructor(data?: ERPaccountingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPaccounting`.
   */
  public static getModelName() {
    return "ERPaccounting";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPaccounting for dynamic purposes.
  **/
  public static factory(data: ERPaccountingInterface): ERPaccounting{
    return new ERPaccounting(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPaccounting',
      plural: 'ERPaccountings',
      path: 'ERPaccountings',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPaccounting.ts